import React, {Fragment} from 'react'
import './block-number-list.sass'


const ListTitleAndSubtitle = ({ item, i }) => {
    const split = item.split(' - ');
    const title = split[0] + ' ';
    let description = '';

    if (split.length > 0) {
        description = split[1];
    }

    return (
        <Fragment key={i}>
            <dt className="BlockNumberList__title">
                <span className="BlockNumberList__number">{i + 1}</span> {title} <span className='font-weight-normal'>{`${description? '-' : ''}`} {description}</span>
            </dt>
        </Fragment>
    )
}

const SubBullets = ({ bullets }) => {
    return bullets.map((bullet, i) => {
        return <p className="m-0">- {bullet}</p>
    })
}

const ListTitleSubBullets = ({ item, i }) => {
    const bullets = item.split(' * ');
    const title = bullets.shift();



    return (
        <div key={i}>
            <dt className="BlockNumberList__title mt-2 mb-0">
                <span className="BlockNumberList__number">{i + 1}</span> {title}
            </dt>
            <SubBullets bullets={bullets}/>
        </div>
    )
}

const getListItem = (listItems) => {
    return listItems.map((item, i) => {
        if (item.includes('*')) {
            return <ListTitleSubBullets item={item} i={i}/>
        }

        return <ListTitleAndSubtitle item={item} i={i}/>
    })
}

const BlockNumberList = ({data}) => (
    <section className={`container-fluid k-section k-max-width--1 mt-0 pt-0 mb-0 pb-0 ${data.classes ? data.classes : ''}`}>
            <dl className="BlockNumberList mb-0">
            {getListItem(data.content)}
        </dl>
    </section>
)

export default BlockNumberList